abstract class BaseState<T> {
  protected stateManager: T | null = null;
  abstract id: string;

  constructor(stateManager: T) {
    this.stateManager = stateManager;
  }

  public onEnter(stateManager: T): void {
    console.log(`Entered ${this.constructor.name}`);
    const stateName = this.constructor.name;

    this.stateManager = stateManager;
  }

  public onExit(): void {
    const stateName = this.constructor.name;

    // Use the colorCode for the exited state message
    console.log(`Exited ${stateName}`);
  }
}

export { BaseState };
